export enum ExtraOptionStatus {
  confirmed = 'CONFIRMED',
  obtainingQuote = 'OBTAININGQUOTE',
  cancelled = 'CANCELLED',
}
